export default function normalizePercentage(value: string): string | null {
    let matches = value.match(/(\d{1,3}(?:,\d{3})*(?:\.\d{0,4})?)%/);
    return matches
        ? matches.slice(1).join("").replace(/,/g, "")
        : null;
}


// WEBPACK FOOTER //
// ./ClientApp/utils/normalizePercentage.ts